export const getParameterByName = (name) => {
    const match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

const populateUTMParameters = () => {
    const mappings = {
        utmSource: 'utm_source',
        utmContent: 'utm_content',
        utmMedium: 'utm_medium',
        utmCampaign: 'utm_campaign',
        utmTerm: 'utm_term'
    };

    for (let key in mappings) {
        let value = getParameterByName(mappings[key]);
        if (value) {
            document.querySelector(`input[name="${key}"]`).value = value;
        }
    }
};

export default populateUTMParameters;